import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import { Text } from 'react-native-paper';

import { LocalizationNameSpace } from '@/localization/types/localizationTypes';
import { useAppTheme } from '@/styles/hooks/useAppTheme';

const MIN_SEARCH_LENGTH = 3;

export const OrganizationSearchHint: FC = () => {
  const theme = useAppTheme();
  const { t } = useTranslation(LocalizationNameSpace.PROFILE_SETTING, {
    keyPrefix: 'components.organization-search'
  });

  return (
    <View style={styles.hintContainer}>
      <Text
        variant="bodyLarge"
        style={{ color: theme.colors.onSurfaceVariant }}
      >
        {t('hint', { count: MIN_SEARCH_LENGTH })}
      </Text>
    </View>
  );
};

const styles = StyleSheet.create({
  hintContainer: {
    paddingHorizontal: 16,
    paddingVertical: 24
  }
});
